<template lang="pug">
    PersonEditCard(v-model="person", :createMode="true" @changedPerson="onChanged")
</template>

<script>
import PersonEditCard from "./PersonEditCard.vue";
import {country} from "../../config.json";

export default {
    components: {PersonEditCard},
    data() {
        const biobank = localStorage.getItem("biobank") || "";
        const match = biobank.match(/^bbmri-eric:ID:([A-Z]{2})_/);
        const inferredCountry = (match && match[1]) || country;
        return {
            person: {country: inferredCountry},
            isChanged: false
        };
    },
    // beforeRouteLeave(to, from, next) {  //check here
    //   if (! this.isChanged) {
    //     next();
    //   }
    //   else {
    //     if (confirm(`You did not save your changes! Still want to leave the form?`)) {
    //       next();
    //     } else {
    //       next(false);
    //     }
    //   }
    // },
    methods: {
      onChanged(isChanged) {
        this.isChanged = isChanged;
      }
    }
}
</script>
